<template>
  <v-card class="card pa-6 mx-auto" elevation="2">
    <div class="px-2 d-flex align-center">
      <v-avatar class="subheading flex-center white--text mr-11"
        ><v-icon large>{{ icone }}</v-icon></v-avatar
      >
      <h2 class="justify-center">{{ title }}</h2>
    </div>

    <div class="my-6 mx-2 px-1 d-flex flex-column justify-center align-center">
      <span class="label py-2">
        {{ textMessage }}
      </span>
      <span class="label observation py-2">
        {{ textObservation }}
      </span>
    </div>

    <div>
      <v-row class="d-flex ma-0 pa-0">
        <v-col cols="12" class="d-flex justify-center">
          <v-btn outlined class="terciary-button mr-2" @click="close" :loading="loading">
            <span>{{ cancelBtn }}</span>
          </v-btn>

          <v-btn class="secondary-button" @click="action" :loading="loading">
            <span>{{ okbtn }}</span>
          </v-btn>
        </v-col>
      </v-row>
    </div>
  </v-card>
</template>

<style scoped>
.card {
  background: #ffffff !important;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25) !important;
  border-radius: 12px !important;
}

.cancelBtn {
  font-weight: bold !important;
  background-color: #ffffff !important;
  border: 1.5px solid #2d3038 !important;
  box-sizing: border-box !important;
  border-radius: 6px !important;
}

.okBtn {
  font-weight: bold !important;
  box-sizing: border-box !important;
  background: #2d3038 !important;
  border-radius: 6px solid #2d3038 !important;
}

.label {
  font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: 29px;
  text-align: justify;
  letter-spacing: 0.15px;

  color: #232021;
}

.observation {
  font-family: Roboto;
  font-style: normal;
  color: grey;
  font-weight: 500;
  font-size: 17px;
  line-height: 25px;
  text-align: justify;
  letter-spacing: 0.15px;

  color: #232021;
}

@media (max-width: 600px) {
  .select-type {
    width: 50% !important;
  }
}

@media (max-width: 600px) {
  .form {
    flex-direction: column;
  }
}
</style>

<script>
import ApiService from "../../../services/ApiService";

export default {
  name: "AprovalModal",

  props: {
    filter: Object,
    nome: String,
    title: String,
    icone: String,
    textMessage: String,
    cancelBtn: String,
    okbtn: String,
    textObservation: String,
  },

  data: () => ({
    loading: false,
    excelDialog: "",
    apiService: new ApiService(),
    resale: Object,
  }),

  methods: {
    close() {
      this.$emit("close");
    },

    action() {
      this.$emit("action");
    },
  },
};
</script>
